<template>
    <div class="page-wrapper">
      <div class="page-title">
        <CIcon name="cil-chart" /> Mortality & Release Percentage
      </div>

        <CRow>
            <CCol md="12">
                <data-filter
                    :tableLength="0"
                    v-model="filter"
                ></data-filter>
            </CCol>
        </CRow>
        <div v-if="loading" class="loader-area">
            <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
        </div>
        
        <CRow v-if="!loading">            
            <CCol md="12" v-if="!error">                
                <CCard>
                    <CCardHeader class="no-backdrop">
                        <span class="card-title mb-0">Percentage Overview</span>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol md="6">
                                <div class="c-callout c-callout-warning">
                                    <small class="h3">Mortality Percentage</small><br>
                                    <strong class="h1">{{mortalityPercentage}}%</strong>
                                </div>                                
                            </CCol>
                            <CCol md="6">
                                <div class="c-callout c-callout-primary">
                                    <small class="h3">Release Percentage</small><br>
                                    <strong class="h1">{{releasePercentage}}%</strong>
                                </div>                                
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>  
            <CCol md="12" v-else>                
                <CCard class="align-items-center">
                    <CCardBody >
                        <p style="text-align:center"><strong ><CIcon name="cil-ban"/><br>Something went wrong!<br>We have noticed some error in your request, please try again later!</strong></p>
                    </CCardBody>
                </CCard>
            </CCol>            
        </CRow>

        <CRow v-if="!loading">            
            <CCol md="12" v-if="!error">                
                <CCard>
                    <CCardHeader class="no-backdrop">
                        <span class="card-title mb-0">Raw Data Breakdown</span>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol md="3">
                                <div class="c-callout c-callout-warning">
                                    <small class="h6">Total Records (TRD)</small><br>
                                    <strong class="h4">{{rawData.trd}}</strong>
                                </div>                                
                            </CCol>
                            <CCol md="3">
                                <div class="c-callout c-callout-warning">
                                    <small class="h6">Died Under Care (DUC)</small><br>
                                    <strong class="h4">{{rawData.duc}}</strong>
                                </div>                                
                            </CCol>
                            <CCol md="3">
                                <div class="c-callout c-callout-primary">
                                    <small class="h6">Dead on Arrival (DOA)</small><br>
                                    <strong class="h4">{{rawData.doa}}</strong>
                                </div>                                
                            </CCol>
                            <CCol md="3">
                                <div class="c-callout c-callout-primary">
                                    <small class="h6">Release (RSD)</small><br>
                                    <strong class="h4">{{rawData.rsd}}</strong>
                                </div>                                
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6">
                                <div class="c-callout c-callout-warning">
                                    <small class="h6">Mortality Percentage Calculation</small><br>
                                    <strong class="h6">(DUC/(TRD - DOA))*100 %</strong>
                                </div>                                
                            </CCol>
                            <CCol md="6">
                                <div class="c-callout c-callout-primary">
                                    <small class="h6">Release Percentage Calculation</small><br>
                                    <strong class="h6">(RSD/(TRD - DOA))*100 %</strong>
                                </div>                                
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>          
        </CRow>
        
    </div>
</template>

<script>
import DataFilter from '../components/dataFilter.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../../store';
import JsonExcel from 'vue-json-excel';


export default {
    name : 'Monthly',
    components: {
        DataFilter,
        PulseLoader,
        JsonExcel,
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,
            filename : 'SaveAnimals_Data.xls',
            showFilter : false,

            histogram : {
                percentage : [],
                values: [],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height : 600
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter : this.graphLabel,
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            style: {
                                fontSize: '14px'
                            }
                        }
                    }
                },
          
            },

            selected : {},
            filter : {
                fromDate : null,
                toDate : null,
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                zone : null,
                outcome : null,
                date : null,
                caseno : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : null,
                startYear : null,
                endYear : null
            },
            graphColours : [
                '#e6194B', 
                '#3cb44b', 
                '#ffe119', 
                '#4363d8', 
                '#f58231', 
                '#911eb4', 
                '#42d4f4', 
                '#f032e6', 
                '#bfef45', 
                '#808000'
            ],
            searchText : '',
            perPage: 12,
            currentPage: 1,
            loading : true,
            filterLoading : true,
            fields : [         
            ],
            download : [],

            loadPage : 1,
            pagesAvailable : 1,          
            mortalityPercentage : 0,
            releasePercentage   : 0,
            error : false,
            rawData : {
                trd : 0,
                duc : 0,
                doa : 0,
                rsd : 0
            }
        }
    },
    beforeMount(){
        var d = new Date();
        var str = d.toISOString();
        str = str.substr(0, 10);
        str = str.replace(/-/g, '');
        this.filename = 'SaveAnimals_Data_'+ str +'.xls';
    },
    created() {

        this.selected = {
            sourceIntervalType : store.state.filters.sourceIntervalType,
            sourceType : store.state.filters.sourceype,
            date : store.state.filters.date,
            startDate : store.state.filters.startDate,
            endDate : store.state.filters.endDate,
            outcome : store.state.filters.outcome,
            zone : store.state.filters.zone,
            class : store.state.filters.class,
            family : store.state.filters.family,
            group : store.state.filters.group,
            identity : store.state.filters.identity,
            caseno : store.state.filters.caseno,
            scientific : store.state.filters.scientific,
            stage : store.state.filters.stage,
            facility : store.state.filters.facility,
            placeOfRescue : store.state.filters.placeOfRescue,
            causeOfDisp : store.state.filters.causeOfDisp,
            month : store.state.filters.month,
            year : store.state.filters.year,
        }

        this.filter = {
            fromDate : this.selected.startDate,
            toDate : this.selected.endDate,
            class : this.selected.class,
            family: this.selected.family,
            group : this.selected.group,
            identity : this.selected.identity,
            scientific : this.selected.scientific,
            zone : this.selected.zone,
            outcome : this.selected.outcome,
            timeType : this.selected.sourceType,
            date : this.selected.date,
            timeIntervalType : this.selected.sourceIntervalType,
            caseno : this.selected.caseno,
            stage : this.selected.stage,
            facility : this.selected.facility,
            placeOfRescue : this.selected.placeOfRescue,
            causeOfDisp : this.selected.causeOfDisp
        } 
    },
    watch : {
        filter : function(newVal, oldVal){
            this.getRecords(true);
        }
    },
    methods: {
        graphLabel(val, opts){
            return (val);
        },    
        getRecords(reset){
            this.loading = true;
            axios({
                url : this.baseURL + "analytics/release-mortality-percentage",
                headers : {
                    authorization : store.state.token
                },
                data : this.filter,
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {         
                    this.mortalityPercentage = res.data.data.mortality;
                    this.releasePercentage = res.data.data.released;    
                    this.rawData =  {
                        trd : res.data.rawData.trd,
                        duc : res.data.rawData.duc,
                        doa : res.data.rawData.doa,
                        rsd : res.data.rawData.rsd
                    }
                    this.loading = false;                                   
                }
                else
                {
                    this.error = true;
                    this.$notify({
                        group   : 'notification',
                        type    : 'error',
                        title   : 'Important message',
                        text    : res.data.message
                    });
                    this.loading = false;  
                }
            })
            .catch(err => {
                console.log(err);
                this.fields = [];
                this.displacementData = [];
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: err.status
                });
                this.loading = false;  
            });  

        },
        onSelectRow(row){
            this.openReport(row[0]._id);

        },
        selectAnimal(item){
        },
        openReport(id){
            window.open(`/existing-case/${id}`, '_blank');
            // this.$router.push({name : 'Conflict Report', params : { surveyid }});
        }
    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>